import { reaction } from 'mobx';

import { company } from '~/company/Company';

import { orderStore, userStore } from '~/stores';

import { ORDER_AGAIN_CONFIG, TOP_PICKS_CONFIG } from './configs';
import { RecommendationStore } from './RecommendationsStore';
import { RecommendationConfig } from './types';

export { ORDER_AGAIN_CONFIG, TOP_PICKS_CONFIG } from './configs';
export { RecommendationStore } from './RecommendationsStore';
export type {
  RecommendationCollection,
  RecommendationCompanyFlag,
  RecommendationConfig,
  RecommendationSource,
} from './types';

export const topPicksStore = new RecommendationStore(TOP_PICKS_CONFIG);
export const orderAgainStore = new RecommendationStore(ORDER_AGAIN_CONFIG);

function createRecommendationReaction(
  store: RecommendationStore,
  config: RecommendationConfig,
): void {
  reaction(
    () => ({
      isAuthorized: userStore.isAuthorized,
      warehouse: orderStore.etaWarehouseCode,
      hasDeliveryAddress: !!userStore.deliveryAddress,
      etaWarehouse: orderStore.etaCalculation?.warehouse.code,
      showSlider: company[config.companyFlag],
    }),
    ({
      isAuthorized,
      warehouse,
      hasDeliveryAddress,
      etaWarehouse,
      showSlider,
    }) => {
      if (hasDeliveryAddress && !etaWarehouse) {
        return;
      }

      if (isAuthorized && warehouse && showSlider) {
        store.productsRequest.run();
      } else {
        store.clearProducts();
      }
    },
    {
      equals: (prev, next) =>
        prev.isAuthorized === next.isAuthorized &&
        prev.warehouse === next.warehouse &&
        prev.hasDeliveryAddress === next.hasDeliveryAddress &&
        prev.showSlider === next.showSlider &&
        (prev.etaWarehouse === next.etaWarehouse ||
          next.etaWarehouse === next.warehouse),
    },
  );
}

createRecommendationReaction(topPicksStore, TOP_PICKS_CONFIG);
createRecommendationReaction(orderAgainStore, ORDER_AGAIN_CONFIG);
